import { Link } from "react-router-dom";

export default function NotFound() {
  return (
    <div data-testid="not-found-page" className="mx-auto flex min-h-[60vh] max-w-xl flex-col items-center justify-center px-4 py-16 text-center">
      <p className="font-heading text-6xl font-black text-orange-500">404</p>
      <h1 className="mt-4 font-heading text-3xl font-black uppercase">Page introuvable</h1>
      <p className="mt-3 text-sm text-slate-400">Cette page n'existe pas ou a été déplacée.</p>
      <div className="mt-8 flex flex-wrap justify-center gap-3">
        <Link to="/" className="rounded-lg bg-orange-500 px-5 py-3 text-sm font-bold uppercase text-[#060B18] transition-all hover:bg-orange-400">
          Retour à l'accueil
        </Link>
        <Link to="/boutique" className="rounded-lg border border-orange-500/40 px-5 py-3 text-sm font-bold uppercase text-orange-400 transition-all hover:bg-orange-500/10">
          Voir la boutique
        </Link>
      </div>
    </div>
  );
}
